export const environment = {
  production: false,
  srecApiUrl: 'https://apim-sprucepowermarketingdesk-stg.azure-api.net',
  srecApiKey: 'f2e0b66acb5141b68be7be10eddf1636'
};